var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronDownIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5568 9.51584L11.0001 13.0725L7.44344 9.51584C7.08594 9.15834 6.50844 9.15834 6.15094 9.51584C5.79344 9.87334 5.79344 10.4508 6.15094 10.8083L10.3584 15.0158C10.7159 15.3733 11.2934 15.3733 11.6509 15.0158L15.8584 10.8083C16.2159 10.4508 16.2159 9.87334 15.8584 9.51584C15.5009 9.1675 14.9143 9.15834 14.5568 9.51584Z",
    fill: "#04B7EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDownIcon);
export default __webpack_public_path__ + "static/media/ChevronDownIcon.3968df11c076c70e066143e2e4d51224.svg";
export { ForwardRef as ReactComponent };